import { AssetManagerSingleCardTemplate } from "../../../../templates";
import { ChangePersonalDetailsForm, useChangePersonalDetails } from "../../../shared";

const ChangePersonalDetails = (): JSX.Element => {
  const { data, isLoading } = useChangePersonalDetails();

  return (
    <div>
      {!isLoading && (
        <AssetManagerSingleCardTemplate pageTitle="Change Personal Details">
          {data && <ChangePersonalDetailsForm defaultValues={data} />}
        </AssetManagerSingleCardTemplate>
      )}
    </div>
  );
};

export default ChangePersonalDetails;
